import { makeStyles } from "@material-ui/core";
import { FC } from "react";

const useStyles = makeStyles({
    'doubleLineText': {
        display: 'flex',
        color: '#617c98',
        justifyContent: 'space-between',
        alignItems: 'center',
        '& hr': {
            borderTop: '0.5px solid #617c98cb',
            boxSizing: 'border-box',
        },
        '& div': {
            fontWeight: 700,
            fontSize: "14px",
            margin: "0.50rem"
        }
    }
})

const DoubleLineText: FC<any> = ({ text, lineWidth }) => {

    const classes = useStyles();

    return (
        <div className={classes.doubleLineText}>
            <hr
                style={{
                    width: lineWidth || "10rem",
                }}
            />
            <div>{text}</div>
            <hr
                style={{
                    width: lineWidth || "10rem",
                }}
            />
        </div>
    )
}

export default DoubleLineText;